/* @flow */

export const ActionTypes = {
    EMAIL_REPLY_CLOSED: 'EMAIL_REPLY_CLOSED',
    EMAIL_REPLY_OPENED: 'EMAIL_REPLY_OPENED',
};

type EmailReplyClosedAction = {type: 'EMAIL_REPLY_CLOSED'};
type EmailReplyOpenedAction = {
    type: 'EMAIL_REPLY_OPENED',
    payload: {
        replyToEmailId: string,
        isReplyingAll: boolean,
    },
};

export type EmailReplyAction = EmailReplyOpenedAction | EmailReplyClosedAction;

/*
 * Action creators
 */
export const closeReplyModal = (): EmailReplyClosedAction => ({
    type: ActionTypes.EMAIL_REPLY_CLOSED,
});

export const openReplyModal = (
    replyToEmailId: string,
    isReplyingAll: boolean = false
): EmailReplyOpenedAction => ({
    type: ActionTypes.EMAIL_REPLY_OPENED,
    payload: {replyToEmailId, isReplyingAll},
});
